/**
 * Human-readable outcome of the booking-confirmation email returned by
 * POST scheduler/createAppointment (JD-408).
 */
const SKIP_REASONS = {
  not_opted_in: "client not opted in",
  no_email: "client has no email",
  invalid_email: "client email is invalid",
  client_not_found: "client not found",
  stylist_not_found: "stylist not found",
  location_not_found: "location not found",
};

/**
 * @param {{status: string, reason?: string, recipient?: string} | undefined} confirmationEmail
 * @returns {{kind: "success" | "warning" | "error", message: string}}
 */
export function describeConfirmationEmail(confirmationEmail) {
  if (!confirmationEmail || !confirmationEmail.status) {
    return { kind: "success", message: "Appointments created successfully." };
  }

  const { status, reason, recipient } = confirmationEmail;

  if (status === "sent") {
    return {
      kind: "success",
      message: recipient
        ? `Appointment created · confirmation email sent to ${recipient}`
        : "Appointment created · confirmation email sent",
    };
  }

  if (status === "skipped") {
    const why = SKIP_REASONS[reason];
    return {
      kind: "warning",
      message: why
        ? `Appointment created · no confirmation email sent (${why})`
        : "Appointment created · no confirmation email sent",
    };
  }

  return {
    kind: "error",
    message: "Appointment created · confirmation email failed to send",
  };
}
